// ~~ Generated. This file cannot be edited directly. Please look at libs/nx-tooling/src/generators/backoffice-project/generator.ts

import { SuspenseLoadingWrapper } from '@backoffice-frontend/patterns'
import { BoumRight } from '@moia-dev/moia-token-claims'
import { lazy } from 'react'
import { InAppMessagesAreaId } from './InAppMessagesAreaId'
import { InAppMessagesAreaNavigation } from './InAppMessagesAreaNavigation'
import { InAppMessagesAreaRoutes } from './InAppMessagesAreaRoutes'

const LazyInAppMessagesComponent = lazy(() => import('./InAppMessagesArea'))

const InAppMessagesComponent = () => (
  <SuspenseLoadingWrapper>
    <LazyInAppMessagesComponent />
  </SuspenseLoadingWrapper>
)

export const InAppMessagesArea = {
  id: InAppMessagesAreaId,
  requiredRight: BoumRight.AREA_IN_APP_MESSAGES,
  NavigationComponent: InAppMessagesAreaNavigation,
  route: {
    path: InAppMessagesAreaRoutes.route,
    component: InAppMessagesComponent,
  },
}
